import React from 'react';
import { FadeIn } from './FadeIn';
const steps = [{
  num: '1',
  title: 'Listen',
  desc: 'Put on your headphones and go through the 60-minute protocol to understand your new "Sleep Map."'
}, {
  num: '2',
  title: 'Implement',
  desc: 'Follow the Core Temp Reset 2 hours before bed tonight.'
}, {
  num: '3',
  title: 'Stabilize',
  desc: 'Use the Emergency Drift-Off audio if you experience a midnight spike to settle your nervous system in seconds.'
}];
export function HowItWorks() {
  return <section className="py-24 md:py-32 bg-gradient-to-b from-[#0B1029] to-[#1A2352] relative" data-id="element-142">
      <div className="container mx-auto px-6 max-w-5xl" data-id="element-143">
        <FadeIn data-id="element-144">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif text-center mb-20 text-[#F5D0A9]" data-id="element-145">
            How It Works
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-12 md:gap-8" data-id="element-146">
          {steps.map((step, i) => <FadeIn key={i} delay={i * 0.2} data-id="element-147">
              <div className="text-center relative" data-id="element-148">
                {i !== steps.length - 1 && <div className="hidden md:block absolute top-10 left-[60%] w-full h-[1px] bg-gradient-to-r from-[#F5D0A9]/30 to-transparent" data-id="element-149" />}
                <div className="w-20 h-20 mx-auto bg-[#F5D0A9]/5 border border-[#F5D0A9]/20 rounded-full flex items-center justify-center mb-8 relative z-10 shadow-[0_0_30px_rgba(245,208,169,0.05)]" data-id="element-150">
                  <span className="text-3xl font-serif text-[#F5D0A9]" data-id="element-151">
                    {step.num}
                  </span>
                </div>
                <h3 className="text-2xl font-serif text-white mb-4" data-id="element-152">
                  {step.title}
                </h3>
                <p className="text-slate-300 font-light leading-relaxed" data-id="element-153">
                  {step.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}